module.exports = __webpack_public_path__ + "static/works-004-9b341f8376b6cab4c786dcf7c485ca4f.jpg";